const getPatientPhone1 = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const primaryPhone = patient['Contact Information']
    ? patient['Contact Information']['Primary Phone']
    : null;
  if (primaryPhone) {
    return primaryPhone.replace('+1 ', '').replace(/[\s()-]/g, '').slice(0, 3);
  }
  return null;
};

export default getPatientPhone1;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientPhone1.js